<template>
  <div class="wrap h100p">


    <slot />


  </div>
</template>

<script>
export default {
  name: "LayoutNone",
};
</script>

<style scoped>

</style>